// src/components/ErrorBoundary.jsx
import React from "react";
import { Box, Typography, Button } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
    console.error("Error component stack:", errorInfo.componentStack);
    // Log the error message to help debug React error #130
    if (error.message?.includes("130") || error.message?.includes("object")) {
      console.error("⚠️ React Error #130 detected - An object is being rendered as a React child");
      console.error("Check component stack above to find the component causing the issue");
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            bgcolor: "grey.900",
            color: "white",
            p: 4,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, color: "error.main" }}>
            ⚠️ Something went wrong
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, textAlign: "center", maxWidth: 600 }}>
            {(() => {
              const err = this.state.error;
              if (!err) return "An unexpected error occurred";
              if (typeof err === "string") return err;
              if (err?.message && typeof err.message === "string") return err.message;
              try {
                return JSON.stringify(err);
              } catch {
                return "An unexpected error occurred";
              }
            })()}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleReset}
            sx={{ mt: 2 }}
          >
            Reload Application
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;









